import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Logo from '../../uielements/Logo';
import { Box, Flex, Spacer, Text } from '@chakra-ui/react'
import LangSwitcher from '../../uielements/LangSwitcher';
import Menu from '../Menu';
import styled from 'styled-components';
import LightsToggle from '../../uielements/LightsToggle'
import { MdSchool } from "react-icons/md";
import { Link } from 'gatsby'

const StyledHeader = styled.header`
    position: ${({ scrollDirection }) => (scrollDirection === 'up' ? 'fixed' : 'relative')};
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: ${({ scrollDirection }) => (scrollDirection === 'up' ? '140px' : 'auto')};
    background-color: ${({ scrollDirection, scrollPosition }) => ((scrollDirection === 'up' && scrollPosition > 350) ? 'rgba(0, 0, 0, 0.6)' : 'transparent')};
    color: white;
    z-index: 999999;

    h1 {
        margin: 0;
    }
`;

const Header = () => {
    const [scrollDirection, setScrollDirection] = useState(null);
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            let lastScrollY = window.scrollY
            const handleScroll = () => {
                const scrollY = window.scrollY
                setScrollPosition(scrollY)
                const direction = (scrollY > lastScrollY) ? "down" : "up"
                if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
                    setScrollDirection(direction)
                    setScrollPosition(scrollY)
                }
                lastScrollY = scrollY > 0 ? scrollY : 0
            };

            window.addEventListener('scroll', handleScroll);

            // Cleanup function to remove the event listener
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }
    }, [scrollDirection]);

    return (
        <StyledHeader scrollDirection={scrollDirection} scrollPosition={scrollPosition}>
            <Box
                px={3}
                py={5}
                pos={'absolute'}
                top={2}
                left={2}
                right={2}
                zIndex={99}
                borderRadius={8}
                display={['none', 'none', 'none', 'block']}
            >
                <Box>
                    <Flex alignItems={'center'} justifyContent={'center'} flexDirection={'column'}>
                        <Logo width="170px" color={'white'} />
                        <Spacer p={2} />
                        <Menu />
                    </Flex>
                    <Box pos={'absolute'} right={2} top={2}>
                        <Flex flexDirection={'row'} alignItems={'center'}>
                            <Box p={1} color={'#fff'} >
                                <Link
                                    target={'_blank'}
                                    rel={'noreferrer'}
                                    to={'https://so.simple.edu.gr/Account/Login'}
                                >
                                    <Box
                                        display={'flex'}
                                        flexDir={'row'}
                                        alignItems={'center'}
                                        css={{
                                            color: '#fff !important'
                                        }}
                                        _hover={{
                                            color: '#FAE823 !important',
                                        }}
                                    >
                                        <MdSchool size={'18px'} />
                                        <Text fontWeight={'bold'} fontSize={'md'} mx={2}>ECLASS</Text>
                                    </Box>
                                </Link>
                            </Box>
                            <Box p={1}>
                                <LangSwitcher />
                            </Box>
                            {/*<Box p={1}>*/}
                            {/*    <LightsToggle />*/}
                            {/*</Box>*/}
                        </Flex>
                    </Box>
                </Box>
            </Box>
        </StyledHeader>
    );
};

Header.propTypes = {
    siteTitle: PropTypes.string,
};

Header.defaultProps = {
    siteTitle: ``,
};

export default Header;
